module.exports = __webpack_public_path__ + "img/demo11.6b0ea6be.jpg";